module.exports = __webpack_public_path__ + "img/logo_light.1d5f3ca0.svg";